import cn from 'classnames';
import type { IItemProps } from 'react-movable';
import { ReorderIcon } from '#assets/ReactSvg.ts';
import styles from './SortableListItem.module.css';

type Props = IItemProps & {
  isDragging: boolean;
  isDisabled: boolean;
  children: React.ReactNode;
  className?: string;
};

export function SortableListItem({ children, isDragging, isDisabled, className, ...props }: Props) {
  return (
    <li
      className={cn(className, styles.SortableListItem, {
        [styles.SortableListItem___dragging]: isDragging,
        'opacity-dim': isDisabled,
      })}
      {...props}
    >
      <ReorderIcon className={styles.SortableListItem_icon} aria-hidden /> {children}
    </li>
  );
}
